import { Avatar, Card, CardContent, Stack, Typography } from "@mui/material";
import { ArrowDownIcon, ArrowUpIcon, CurrencyDollarIcon } from "@phosphor-icons/react";

const sx = {
    minWidth: 220,
    borderRadius: 2,
    // add/adjust styles as needed
};

export default function DsNumberCard({ title, description, diff, trend, value }) {
    const TrendIcon = trend === 'up' ? ArrowUpIcon : ArrowDownIcon;
    const trendColor = trend === 'up' ? 'var(--mui-palette-success-main)' : 'var(--mui-palette-error-main)';

    return (
        <Card sx={sx}>
            <CardContent>
                <Stack spacing={3}>
                    <Stack direction="row" sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }} spacing={3}>
                        <Stack spacing={1}>
                            <Typography color="text.secondary" variant="overline" sx={{ fontSize: 9 }}>
                                {title}
                            </Typography>
                            <Typography variant="h4" sx={{ fontSize: 26 }}>{value}</Typography>
                        </Stack>
                        <Avatar sx={{ backgroundColor: 'var(--mui-palette-primary-main)', height: '56px', width: '56px' }}>
                            <CurrencyDollarIcon fontSize="var(--icon-fontSize-lg)" />
                        </Avatar>
                    </Stack>
                    {diff ? (
                        <Stack sx={{ alignItems: 'center' }} direction="row" spacing={2}>
                            <Stack sx={{ alignItems: 'center' }} direction="row" spacing={0.5}>
                                <TrendIcon color={trendColor} fontSize="var(--icon-fontSize-md)" />
                                <Typography color={trendColor} variant="body2">
                                    {diff}%
                                </Typography>
                            </Stack>
                            <Typography color="text.secondary" variant="caption">
                                {description}
                            </Typography>
                        </Stack>
                    ) : null}
                </Stack>
            </CardContent>
        </Card>
    );
}